<template>
  <el-container class="tender-layout">
    <el-header style="height: auto" class="lay-header">
      <tender-header></tender-header>
    </el-header>
    <el-container>
      <el-aside width="340px" class="lay-aside">
        <tender-menu></tender-menu>
      </el-aside>
      <el-main class="lay-main" ref="noticeContainer">
        <tender-notice ref="tenderNotice"></tender-notice>
        <div class="lay-tools">
          <el-button type="primary" @click="scrollToFormItem" plain>填写验证</el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import utils from './js/utils'
import hooks from './js/hooks'
import TenderHeader from './comps/tender-header'
import TenderMenu from './comps/tender-menu'
import TenderNotice from './comps/tender-notice'
export default {
  name: 'BearTenderEditor',
  components: {
    TenderHeader,
    TenderMenu,
    TenderNotice
  },
  data() {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init () {
      this.requestConfig().then(config => {
        this.setFormItems(config)
        this.setConfig(config)
        this.resetCount(config)
        this.setReady(true)
        this.$nextTick(() => {
          this.setValidatorCount()
        })
      })
    },
    initScrollEvent() {
      utils.scrollEventWithMenu(on => {
        this.setTenderMenuOn(on)
      }, this.$refs.noticeContainer)
    },
    resetCount(config) {
      let count = hooks.initTenderCount(config)
      this.setCount(count)
    },
    scrollToFormItem() {
      this.$refs.tenderNotice.scrollToFormItem(e => {
        this.$message.success('填写验证完成！')
      }, e => {
        this.$message.error('还有字段没有填写完整！')
      })
    },
    ...mapMutations([
      'setConfig', 'setCount', 'setReady', 'setTenderMenuOn', 'setScrollToId', 'setFormItems'
    ]),
    ...mapActions([
      'requestConfig', 'setValidatorCount'
    ])
  },
  computed: {
    ...mapState([
      'config', 'ready'
    ])
  }
}
</script>
<style lang="scss" scoped>
.tender-layout {
  height: 100%;
  .lay-header {
    background: #f5f7f9;
    border-bottom: 10px solid #f1f2f7;
  }
  .lay-aside {
    position: relative;
    border-right: 10px solid #f1f2f7;
  }
  .lay-main {
    position: relative;
  }
  .lay-tools {
    position: absolute;
    z-index: 1;
    bottom: 10px;
    right: 10px;
  }
}
</style>